<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import BLabel from "@/components/common/bLabel.vue";
import CountryFlag from "@/components/common/CountryFlag.vue";

type TJobOfferComboItem = {
  title: string;
  countryId?: string;
  code?: string;
  endDate?: string | Date | null;
};

const props = defineProps<{
  offer: TJobOfferComboItem;
}>();

const { t } = useI18n();

// Same rule as the API: an offer expires once its end date is reached
const isExpired = computed(
  () => !!props.offer.endDate && new Date(props.offer.endDate) <= new Date(),
);
</script>

<template>
  <div class="flex items-start gap-2 min-w-0">
    <CountryFlag :country="offer.countryId" class="mt-0.5" />
    <div class="flex flex-col gap-0.5 min-w-0">
      <span class="wrap-break-word">{{ offer.title }}</span>
      <div v-if="offer.code || isExpired" class="flex flex-wrap items-center gap-2">
        <span v-if="offer.code" class="subtitle text-xs">
          {{ t("modals.filter.jobOffer.reference", { code: offer.code }) }}
        </span>
        <BLabel v-if="isExpired" size="dense" bg-color="disabled-op">
          {{ t("modals.filter.jobOffer.expired") }}
        </BLabel>
      </div>
    </div>
  </div>
</template>
